import { FC } from "react";


interface IStrengthCard {
    strengthCard: any,
    key?: number
}

const StrengthCard: FC<IStrengthCard> = (props) => {
    
    const strengthCard = props;

    return (
        <div className="strength_card_container_statistics">
                <div className="strength_card_wrapper_statistics">
                    <p className="card_text_statistics">{strengthCard.strengthCard.description}</p>
                </div>
        </div>
    )
};

export default StrengthCard;